/**
 * Shown after a Manual Impact Assessment BPMN task submit succeeds.
 * Figma: GRI UI/UX DESIGN node 5518-16390
 */

import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export interface ManualAssessmentSubmitSuccessProps {
  onGoBackToMyTask: () => void;
  onViewInHistory: () => void;
}

const TITLE = "Task Submit Successfully";
const DESCRIPTION =
  "This task has been completed and recorded. Return to your task list for other pending tasks, or view the details in assessment history.";

export const ManualAssessmentSubmitSuccess: React.FC<
  ManualAssessmentSubmitSuccessProps
> = ({ onGoBackToMyTask, onViewInHistory }) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: 420,
        px: 3,
        py: 6,
      }}
    >
      <CheckCircleIcon
        sx={{
          fontSize: 72,
          color: "success.main",
          mb: 2.5,
        }}
        aria-hidden
      />
      <Typography
        variant="h5"
        component="h1"
        sx={{
          fontWeight: 700,
          color: "text.primary",
          mb: 1.5,
        }}
      >
        {TITLE}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          maxWidth: 520,
          mb: 4,
          lineHeight: 1.6,
        }}
      >
        {DESCRIPTION}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 2,
          "& .MuiButton-root": {
            textTransform: "none",
            minWidth: 180,
          },
        }}
      >
        <Button variant="outlined" color="primary" onClick={onGoBackToMyTask}>
          Go back to My Task
        </Button>
        <Button variant="contained" color="primary" onClick={onViewInHistory}>
          View in history
        </Button>
      </Box>
    </Box>
  );
};

export default ManualAssessmentSubmitSuccess;
